/**
 * Sidebar-matched icons for open page windows (same as Dashboard.vue sidebar).
 * Rules are ordered most-specific first.
 */

const PATH_ICON_RULES = [
  // Consultant
  { match: (p) => p.includes('/consultant/center'), icon: 'bi bi-house-door' },
  { match: (p) => p.includes('/consultant/add-customer-consultant'), icon: 'bi bi-person-plus' },
  { match: (p) => p.includes('/consultant/list'), icon: 'bi bi-people' },
  { match: (p) => p.includes('/consultant/receive-payment'), icon: 'bi bi-cash-coin' },
  { match: (p) => p.includes('/consultant/timesheet-summary'), icon: 'bi bi-bar-chart' },
  { match: (p) => p.includes('/consultant/timesheet'), icon: 'bi bi-clock-history' },
  { match: (p) => p.includes('/consultant/invoice'), icon: 'bi bi-receipt' },
  { match: (p) => p.includes('/consultant/contract-details'), icon: 'bi bi-file-earmark-text' },
  { match: (p) => p.includes('/consultant/contract-tracking'), icon: 'bi bi-bullseye' },
  { match: (p) => p.includes('/consultant/benefits/types'), icon: 'bi bi-tags' },
  { match: (p) => p.includes('/consultant/benefits/plans'), icon: 'bi bi-clipboard2-heart' },
  { match: (p) => p.includes('/consultant/benefits/category'), icon: 'bi bi-grid' },
  { match: (p) => p.includes('/consultant/benefits'), icon: 'bi bi-heart-pulse' },
  { match: (p) => p.includes('/consultant/payroll/history'), icon: 'bi bi-clock-history' },
  { match: (p) => p.includes('/consultant/payroll/record/manual'), icon: 'bi bi-pencil-square' },
  { match: (p) => p.includes('/consultant/payroll/record'), icon: 'bi bi-plus-circle' },
  { match: (p) => p.includes('/consultant/payroll/to-consultants'), icon: 'bi bi-people' },
  { match: (p) => p.includes('/consultant/payroll/staging/') && p.includes('/consultants'), icon: 'bi bi-people' },
  { match: (p) => p.includes('/consultant/payroll/staging'), icon: 'bi bi-bookmark-star' },
  { match: (p) => p.includes('/consultant/payroll'), icon: 'bi bi-wallet2' },

  // Customer
  { match: (p) => p.includes('/customers/center'), icon: 'bi bi-house-door' },
  { match: (p) => p.includes('/customers/new-credit-memo'), icon: 'bi bi-receipt-cutoff' },
  { match: (p) => p.includes('/customers/new-cash-sale'), icon: 'bi bi-cash-stack' },
  { match: (p) => p.includes('/customers/create-invoice'), icon: 'bi bi-file-earmark-plus' },
  { match: (p) => p.includes('/customers/new-invoice'), icon: 'bi bi-file-earmark-text' },
  { match: (p) => p.includes('/customers/new-service-item') || p.includes('/customers/service-item'), icon: 'bi bi-box' },
  { match: (p) => p.includes('/customers/new') && !p.includes('invoice'), icon: 'bi bi-person-plus' },
  { match: (p) => p.includes('/customers/prepayment'), icon: 'bi bi-wallet2' },
  { match: (p) => p.includes('/customers/receive-payment'), icon: 'bi bi-cash-coin' },
  { match: (p) => p.includes('/customers/refund'), icon: 'bi bi-arrow-counterclockwise' },
  { match: (p) => p.includes('/customers/list'), icon: 'bi bi-people' },
  { match: (p) => p.includes('/customers/invoices'), icon: 'bi bi-receipt' },
  { match: (p) => p.includes('/customers/items'), icon: 'bi bi-box-seam' },
  { match: (p) => p.includes('/customers/edit'), icon: 'bi bi-person-plus' },

  // Vendor
  { match: (p) => p.includes('/vendors/center'), icon: 'bi bi-house-door' },
  { match: (p) => p.includes('/vendors/new-vendor'), icon: 'bi bi-shop' },
  { match: (p) => p.includes('/vendors/service-item') || p.includes('/vendors/product-item'), icon: 'bi bi-box-arrow-in-down' },
  { match: (p) => p.includes('/vendors/cash-purchase'), icon: 'bi bi-cash-stack' },
  { match: (p) => p.includes('/vendors/vendor-credit'), icon: 'bi bi-credit-card' },
  { match: (p) => p.includes('/vendors/write-check'), icon: 'bi bi-pencil-square' },
  { match: (p) => p.includes('/vendors/print-check'), icon: 'bi bi-printer' },
  { match: (p) => p.includes('/vendors/enter-bill'), icon: 'bi bi-file-earmark-text' },
  { match: (p) => p.includes('/vendors/create-bill'), icon: 'bi bi-file-earmark-plus' },
  { match: (p) => p.includes('/vendors/draft-bills'), icon: 'bi bi-file-earmark-diff' },
  { match: (p) => p.includes('/vendors/mail-sources'), icon: 'bi bi-envelope-check' },
  { match: (p) => p.includes('/vendors/pay-bill'), icon: 'bi bi-cash' },
  { match: (p) => p.includes('/vendors/bills'), icon: 'bi bi-receipt' },
  { match: (p) => p.includes('/vendors/record-expenses'), icon: 'bi bi-journal-text' },
  { match: (p) => p.includes('/vendors/list'), icon: 'bi bi-shop' },
  { match: (p) => p.includes('/vendors/portal-hub'), icon: 'bi bi-box-arrow-in-right' },
  { match: (p) => p.includes('/vendors/items'), icon: 'bi bi-box-seam' },
  { match: (p) => p.includes('/vendors/payments'), icon: 'bi bi-wallet2' },

  // Inventory
  { match: (p) => p.includes('/inventory/center') || p.includes('/inventory/centre'), icon: 'bi bi-house-door' },
  { match: (p) => p.includes('/inventory/build-assembly'), icon: 'bi bi-tools' },
  { match: (p) => p.includes('/inventory/stock-adjustment/new'), icon: 'bi bi-arrow-left-right' },
  { match: (p) => p.includes('/inventory/new-item') || p.includes('/new-inventory-item'), icon: 'bi bi-box' },
  { match: (p) => p.includes('/inventory/new-assembly') || p.includes('/new-inventory-assembly'), icon: 'bi bi-boxes' },
  { match: (p) => p.includes('/inventory/stock-adjustment'), icon: 'bi bi-arrow-left-right' },
  { match: (p) => p.includes('/inventory/items'), icon: 'bi bi-box-seam' },

  // Banking
  { match: (p) => p.includes('/banking/new-account'), icon: 'bi bi-bank' },
  { match: (p) => p.includes('/banking/write-check'), icon: 'bi bi-pencil-square' },
  { match: (p) => p.includes('/banking/transfer-fund'), icon: 'bi bi-arrow-left-right' },
  { match: (p) => p.includes('/banking/pay-credit-card'), icon: 'bi bi-credit-card' },
  { match: (p) => p.includes('/banking/make-deposit'), icon: 'bi bi-arrow-down-circle' },
  { match: (p) => p.includes('/banking/reconciliations-history'), icon: 'bi bi-clock-history' },
  { match: (p) => p.includes('/banking/accounts'), icon: 'bi bi-bank2' },
  { match: (p) => p.includes('/banking/credit-cards'), icon: 'bi bi-credit-card-2-front' },
  { match: (p) => p.includes('/banking/loans'), icon: 'bi bi-cash-stack' },
  { match: (p) => p.includes('/banking/organization-loans/record-payment'), icon: 'bi bi-cash-coin' },
  { match: (p) => p.includes('/banking/organization-loans/record-collection'), icon: 'bi bi-cash-stack' },
  { match: (p) => p.includes('/banking/organization-loans'), icon: 'bi bi-building' },

  // Company
  { match: (p) => /\/company\/[^/]+\/dashboard\/?$/.test(p), icon: 'bi bi-grid-3x3-gap' },
  { match: (p) => p.includes('/dashboard/overview'), icon: 'bi bi-house' },
  { match: (p) => p.includes('/dashboard/importcsv'), icon: 'bi bi-file-earmark-arrow-up' },
  { match: (p) => p.includes('/import-staging') || p.includes('/receipt-import-staging') || p.includes('/credit-card-import-staging'), icon: 'bi bi-clipboard2-check' },
  { match: (p) => p.includes('/journalentry'), icon: 'bi bi-journal-text' },
  { match: (p) => p.includes('/dashboard/transactions'), icon: 'bi bi-arrow-left-right' },
  { match: (p) => p.includes('/new-account') || p.includes('/add-account'), icon: 'bi bi-plus-circle' },
  { match: (p) => p.includes('/company-preferences'), icon: 'bi bi-gear' },
  { match: (p) => p.includes('/company/budget'), icon: 'bi bi-pie-chart' },

  // Settings
  { match: (p) => p.includes('/settings/users'), icon: 'bi bi-people' },
  { match: (p) => p.includes('/settings/update-profile'), icon: 'bi bi-person-circle' },
  { match: (p) => p.includes('/settings/change-password'), icon: 'bi bi-key-fill' },
  { match: (p) => p.includes('/settings/session-alert'), icon: 'bi bi-alarm' },
  { match: (p) => p.includes('/settings/email-setup'), icon: 'bi bi-envelope' },
  { match: (p) => p.includes('/settings/email-signature'), icon: 'bi bi-pen' },
  { match: (p) => p.includes('/settings/translation'), icon: 'bi bi-translate' },
  { match: (p) => p.includes('/settings/ui-preferences'), icon: 'bi bi-palette' },
  { match: (p) => p.includes('/settings/document-branding'), icon: 'bi bi-brush' },
  { match: (p) => p.includes('/settings/check-print'), icon: 'bi bi-printer' },
  { match: (p) => p.includes('/settings/integration-keys'), icon: 'bi bi-key' },
  { match: (p) => p.includes('/settings/messaging-notifications'), icon: 'bi bi-chat-dots' },
  { match: (p) => p.includes('/settings/email-notifications'), icon: 'bi bi-envelope-check' },
  { match: (p) => p.includes('/settings/dunning-letter-categories'), icon: 'bi bi-envelope-exclamation' },
  { match: (p) => p.includes('/settings/journal-entry-guide'), icon: 'bi bi-journal-bookmark' },
  { match: (p) => p.includes('/settings/account-configuration'), icon: 'bi bi-sliders' },
  { match: (p) => p.includes('/settings/data-export'), icon: 'bi bi-download' },
  { match: (p) => p.includes('/settings/data-import'), icon: 'bi bi-upload' },
  { match: (p) => p.includes('/settings/company'), icon: 'bi bi-building' },

  // Reports & tracker
  { match: (p) => p.includes('/dashboard/reports'), icon: 'bi bi-file-earmark-text' },
  { match: (p) => p.includes('/reports/'), icon: 'bi bi-file-earmark-bar-graph' },
  { match: (p) => p.includes('/dashboard/tracker'), icon: 'bi bi-currency-dollar' },

  // Module fallbacks
  { match: (p) => p.includes('/consultant'), icon: 'bi bi-person' },
  { match: (p) => p.includes('/customers'), icon: 'bi bi-people' },
  { match: (p) => p.includes('/vendors'), icon: 'bi bi-shop' },
  { match: (p) => p.includes('/inventory'), icon: 'bi bi-box-seam' },
  { match: (p) => p.includes('/banking'), icon: 'bi bi-bank' },
  { match: (p) => p.includes('/settings'), icon: 'bi bi-gear' },
  { match: (p) => p.includes('/company'), icon: 'bi bi-building' },
];

const DEFAULT_ICON = 'bi bi-file-earmark-text';

function normalizePath(routeOrPath) {
  if (!routeOrPath) return '';
  const raw = typeof routeOrPath === 'string'
    ? routeOrPath
    : routeOrPath.path || routeOrPath.fullPath || '';
  return raw.split('?')[0].split('#')[0];
}

function isStagedBatchRecordPayroll(routeOrPath) {
  if (!routeOrPath) return false;
  if (typeof routeOrPath === 'object' && routeOrPath.query?.stagedBatchId) {
    return normalizePath(routeOrPath).includes('/consultant/payroll/record');
  }
  const raw = typeof routeOrPath === 'string' ? routeOrPath : routeOrPath.fullPath || '';
  return raw.includes('/consultant/payroll/record') && /[?&]stagedBatchId=/.test(raw);
}

export function getIconFromRoute(route) {
  if (isStagedBatchRecordPayroll(route)) return 'bi bi-bookmark-star';
  const path = normalizePath(route);
  if (!path) return DEFAULT_ICON;

  const rule = PATH_ICON_RULES.find((entry) => entry.match(path));
  return rule ? rule.icon : DEFAULT_ICON;
}

export function getIconForWindow(win) {
  if (win?.icon) return win.icon;
  return getIconFromRoute(win);
}
